// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 368) return "static/chunks/b8fbd430-442396932b1d2e71.js";
	if (chunkId === 702) return "static/chunks/702-49705a5b56847e49.js";
	if (chunkId === 354) return "static/chunks/354-c752b2d8a652c939.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"112":"layout__minimal","136":"datadog_browser_logs","687":"datadog_browser_rum","818":"layout__client_site_chrome_ui"}[chunkId] || chunkId) + "." + {"103":"2bac5e365e4dd528","112":"18664fdc0ef4e5f5","136":"e7b3d9af5e7407ed","648":"b9f629f5f1e3c53a","687":"fb068906195d23fe","739":"4776ee183938722e","818":"7681360b3aa34802"}[chunkId] + ".js";
};